import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconLockOff } from '@tabler/icons-react';

import { useUnlockInstPage } from '../../../../api/unlockInstPage';
import { InstPage } from '../../../../types';

import { ConfirmModal } from '@/components/Modals/Confirm';

export const UnlockButton = ({ page }: { page: InstPage }) => {
  const unlockInstPage = useUnlockInstPage();

  return (
    <Tooltip label="Unblock page">
      <ActionIcon
        variant="filled"
        color="orange"
        disabled={unlockInstPage.isLoading}
        onClick={() => {
          NiceModal.show(ConfirmModal, {
            title: `Unblock page (${page.name})?`,
            onSuccess: () => unlockInstPage.mutate({ pageId: page._id }),
          });
        }}
        radius="md"
      >
        <IconLockOff size={20} />
      </ActionIcon>
    </Tooltip>
  );
};
